<template>
      <div id="addColumn">
      <h3 class="text-center pt-5 text-info">Add Column Form</h3>
      <div class="container">
        <div id="addColumn-row" class="row justify-content-center align-items-center">
          <div id="addColumn-column" class="col-md-6">
            <div id="addColumn-box" class="col-md-12">
              <form id="addColumn-form" class="form" v-on:submit.prevent="addColumn">
                <h3 class="text-center text-info">Add Column</h3>
                <h4 class="text-center text-info"> in {{organizationName}} </h4>
                <div class="form-group">
                  <label for="username" class="text-info" >Title:</label>
                  <br />
                  <input
                    type="text"
                    name="username"
                    id="username"
                    class="form-control"
                    v-model="columnTitle"
                  />
                </div>
                <div class="form-group">
                  
                </div>
                
                <div class="form-group">
                  <input type="submit" name="submit" class="btn btn-info btn-md" value="Save Task" />
                  <a class="text-info" v-on:click="homePage()">Back to Home</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
export default {
    data(){
        return{
            organizationId:localStorage.organizationId,
            organizationName:localStorage.organizationName,
            columnTitle:'',
        }
    },
    methods:{
        homePage(){
            this.$emit('homePage')
        },
        addColumn(){
            let payload={
                title:this.columnTitle,
                id:this.organizationId,
            }
            this.$emit('addColumn',payload)

        }
    }

}
</script>

<style>

</style>